var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/martech/Homepage/HeroImageNewCssComponent/HeroImageNewCssComponent.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { imageSrc } from '../utils/helper';
import { useOnsiteMessagingImpressionEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingImpressionEvent';
import { useOnsiteMessagingIntentToShowEvent } from '../../../../internal/OnsiteMessageEventingHooks/useOnsiteMessagingIntentToShowEvent';
import { HeroImage } from './HeroImage';
export var HeroImageNewCssComponent = function HeroImageNewCssComponent(_ref) {
  var mobileImg = _ref.mobileImg,
      mobileImg2x = _ref.mobileImg2x,
      mobileWebp = _ref.mobileWebp,
      mobileWebp2x = _ref.mobileWebp2x,
      tabletPortraitImg = _ref.tabletPortraitImg,
      tabletPortraitImg2x = _ref.tabletPortraitImg2x,
      tabletPortraitWebp = _ref.tabletPortraitWebp,
      tabletPortraitWebp2x = _ref.tabletPortraitWebp2x,
      tabletLandscapeImg = _ref.tabletLandscapeImg,
      tabletLandscapeImg2x = _ref.tabletLandscapeImg2x,
      tabletLandscapeWebp = _ref.tabletLandscapeWebp,
      tabletLandscapeWebp2x = _ref.tabletLandscapeWebp2x,
      desktopImg = _ref.desktopImg,
      desktopImg2x = _ref.desktopImg2x,
      desktopWebp = _ref.desktopWebp,
      desktopWebp2x = _ref.desktopWebp2x,
      eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      Head = _ref.Head;
  var ref = useOnsiteMessagingImpressionEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  useOnsiteMessagingIntentToShowEvent({
    eventData: eventData,
    newLaneEventData: newLaneEventData,
    additionalClickStreamData: additionalClickStreamData
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(HeroImage, {
    mobileImg: imageSrc(mobileImg),
    mobileImg2x: imageSrc(mobileImg2x),
    mobileWebp: imageSrc(mobileWebp),
    mobileWebp2x: imageSrc(mobileWebp2x),
    tabletPortraitImg: imageSrc(tabletPortraitImg),
    tabletPortraitImg2x: imageSrc(tabletPortraitImg2x),
    tabletPortraitWebp: imageSrc(tabletPortraitWebp),
    tabletPortraitWebp2x: imageSrc(tabletPortraitWebp2x),
    tabletLandscapeImg: imageSrc(tabletLandscapeImg),
    tabletLandscapeImg2x: imageSrc(tabletLandscapeImg2x),
    tabletLandscapeWebp: imageSrc(tabletLandscapeWebp),
    tabletLandscapeWebp2x: imageSrc(tabletLandscapeWebp2x),
    desktopImg: imageSrc(desktopImg),
    desktopImg2x: imageSrc(desktopImg2x),
    desktopWebp: imageSrc(desktopWebp),
    desktopWebp2x: imageSrc(desktopWebp2x),
    Head: Head,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 13
    }
  }));
};
HeroImageNewCssComponent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Identifies mobile image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileImg: PropTypes.object.isRequired,

  /**
   * Identifies mobile image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileImg2x: PropTypes.object.isRequired,

  /**
   * Identifies mobile webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp: PropTypes.object.isRequired,

  /**
   * Identifies mobile webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  mobileWebp2x: PropTypes.object.isRequired,

  /**
   * Identifies tablet portrait image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg: PropTypes.object.isRequired,

  /**
   * Identifies tablet portrait image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitImg2x: PropTypes.object.isRequired,

  /**
   * Identifies tablet portrait webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp: PropTypes.object.isRequired,

  /**
   * Identifies tablet portrait webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletPortraitWebp2x: PropTypes.object.isRequired,

  /**
   * Identifies tablet landscape image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg: PropTypes.object.isRequired,

  /**
   * Identifies tablet landscape image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeImg2x: PropTypes.object.isRequired,

  /**
   * Identifies tablet landscape webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp: PropTypes.object.isRequired,

  /**
   * Identifies tablet landscape webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  tabletLandscapeWebp2x: PropTypes.object.isRequired,

  /**
   * Identifies desktop image media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg: PropTypes.object.isRequired,

  /**
   * Identifies desktop image 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopImg2x: PropTypes.object.isRequired,

  /**
   * Identifies desktop webp media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp: PropTypes.object.isRequired,

  /**
   * Identifies desktop webp 2x media.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  desktopWebp2x: PropTypes.object.isRequired,

  /**
   * Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  eventData: PropTypes.object,

  /**
   * New Lane Event data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  newLaneEventData: PropTypes.object,

  /**
   * Additional Clickstream data object, passed by parent component
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,

  /**
   * Head to pass to <HeroImage>
   */
  // eslint-disable-next-line zillow/react/require-default-props
  Head: PropTypes.func
} : {};
HeroImageNewCssComponent.defaultProps = {
  eventData: {},
  newLaneEventData: {},
  additionalClickStreamData: {},
  Head: undefined
};